import { PaysafeEventType } from '../../models/paysafe/paysafe-event-type.enum';
import { PaysafeEvent } from '../../models/paysafe/paysafe-event.interface';
import { PaysafeFormField } from '../../models/paysafe/paysafe-form-field.enum';

export const mockPaysafeEvent: PaysafeEvent = {
  type: PaysafeEventType.Blur,
  target: {
    fieldName: PaysafeFormField.CardNumber,
  },
  data: {
    isEmpty: false,
  },
};
